export const colors = {
  actionBackground: '#FEA715',
  actionText: '#101820',
  cardBackgroundDark: '#101820',
  cardSurface: '#F8F5F1',
  cardBorder: '#E5E0D8',
  textMuted: '#D6D6D6',
  textSubtle: '#F2F4F7',
  textTimestamp: '#9CA3AF',
  textError: '#B91C1C',
  textLabel: '#4B5563',
  textValue: '#111827',
  textStatus: '#9A3412',
  textSubtitle: '#6B7280',
  textTitle: '#1F2937'
};
